module.exports = __webpack_public_path__ + "img/logo_primary.9d6f7f7.svg";